import axios, { AxiosError, AxiosResponse } from "axios";
import { useMutation } from "react-query";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { carrierUrls } from "../../URL/ApplicationUrls";
import Carrier from "../Carrier";
import { MdmApiError } from "../../Errors/MdmApiError";
import { addSuccessMessage } from "../../Messages/successMessages";
import { apiErrorNotificationToast } from "../../Errors/apiErrorNotificationToast";

export const useAddCarrier = () => {
  const navigate = useNavigate();

  return useMutation({
    mutationFn: (carrier: Carrier) => {
      return axios.post<Carrier>(carrierUrls.addCarrier.apiUrl, carrier);
    },
    onSuccess: async (response: AxiosResponse<Carrier>) => {
      navigate(carrierUrls.carrierWithId(response.data.Id).uiPath);
      toast.success(addSuccessMessage(response.data.Id, "Carrier"));
    },
    onError: (error: AxiosError<MdmApiError>) => {
      apiErrorNotificationToast(error);
    },
  });
};
